<script>
    import {PATH_PREFIX} from '../../apiUrls.js';

    import { approvalDecision } from './diffStore.js';
    import { onMount } from 'svelte';
    import { object, string } from 'yup';
    import { validateForm } from '../Form/utils.js';
    import { get, post } from '../../utils.js';
    import { sgettext } from '../../i18n.js';
    import Attachments from './Attachments.svelte';
    import ApprovalForm from './ApprovalForm.svelte';
    import Button from '../Button.svelte';
    import Comments from '../common/Comments/Comments.svelte';
    import Modal from '../Modal.svelte';


    export let commentsUrl = `${PATH_PREFIX}/sw/api/builder/approval/{0}/comments/`;
    export let purposeUrl = `${PATH_PREFIX}/sw/api/builder/approval/{0}/purpose/`;
    export let postUrl = `${PATH_PREFIX}/sw/api/builder/approval/{0}/request/`;
    export let awaitingReview = false;
    export let awaitingControl = false;
    export let awaitingStrategy = false;
    export let awaitingActivity = false;
    export let avId;
    
    var approvalLoading = false;
    var approvalComments = [];
    var comment = '';
    var purpose = '';
    let fieldIsValid = initialFieldValidations();
    let media = null;
    var sending = false;
    let mediaInput;
    let editorCommentLabel = '';
    let editorCommentLabelTooltip = '';

    const reviewerCommentLabel = sgettext('$$REVIEWER_COMMENTS$$');
    const controlOwnerCommentLabel = sgettext('$$CONTROL_OWNER_COMMENTS$$');
    const strategyApproverCommentLabel = sgettext('$$STRATEGY_APPROVER_COMMENTS$$');
    const activityApproverCommentLabel = sgettext('$$ACTIVITY_APPROVER_COMMENTS$$');

    const reviewerCommentTooltip = sgettext('$$REVIEWER_REQUIRED_REVIEW_ATTACHMENTS$$');
    const controlOwnerCommentTooltip = sgettext('$$CONTROL_OWNER_APPROVING_CRITICAL_PER$$');
    const strategyApproverCommentTooltip = sgettext('$$STRATEGY_APPROVER_APPROVING_INSTRUCTION$$');
    const activityApproverCommentTooltip = sgettext('$$ACTIVITY_APPROVER_ENSURING_RIGHT_PEOPLE$$');

    $: title = $approvalDecision ? (awaitingReview ? sgettext('$$ENDORSE_CHANGES$$') : sgettext('$$APPROVE_CHANGES$$')) : sgettext('$$REJECT_CHANGES$$');
    $: cleanupAttachments = false;
    $: attachments = [];

    $: if (awaitingReview) {
        editorCommentLabel = reviewerCommentLabel;
        editorCommentLabelTooltip = reviewerCommentTooltip;
    } else if (awaitingControl) {
        editorCommentLabel = controlOwnerCommentLabel;
        editorCommentLabelTooltip = controlOwnerCommentTooltip;
    } else if (awaitingStrategy) {
        editorCommentLabel = strategyApproverCommentLabel;
        editorCommentLabelTooltip = strategyApproverCommentTooltip;
    } else if (awaitingActivity) {
        editorCommentLabel = activityApproverCommentLabel;
        editorCommentLabelTooltip = activityApproverCommentTooltip;
    }

    const modalId = 'approvalModal';
    const approvalSchema = object().shape({
        comment: string().required(sgettext('$$REQUIRED_FIELD$$'))
    });

    function onCancel() {
        cleanupAttachments = true;
        jQuery(`#${modalId}`).modal('hide');
    }

    function initialFieldValidations() {
        return {
            purpose: {
                isValid: true,
                errors: '',
            },
            comment: {
                isValid: true,
                errors: '',
            },
        };
    }

    async function handleConfirm() {
        try {
            var data = {
                comment: comment,
                attachments: attachments.map(attachment => attachment.id)
            }
            await validateForm(approvalSchema, data);
            sending = true;
            data.progress = $approvalDecision;
            const response = await post(postUrl, data);
            
            if (response.ok) {
                const res = await response.json();
                jQuery(modalId).modal('hide');
                window.location = res.url;
            } else {
                //TODO: show error message
                sending = false;
            }
        } catch (errors) {
            fieldIsValid = initialFieldValidations();
            errors.inner.forEach((er) => {
                fieldIsValid[er.path].isValid = false;
                fieldIsValid[er.path].errors = er.message;
            })
            sending = false;
        }
    }

    onMount(async () => {
        approvalLoading = true;
        const response = await get(commentsUrl);
        approvalComments = await response.json();
        approvalLoading = false;
        const purposeResponse = await get(purposeUrl);
        const purposeContent = await purposeResponse.json();
        purpose = purposeContent.purpose;
    });
</script>

<Modal id={modalId} {title} additional_info_needed={true} on:cancel>
  <div slot="body">
    <ApprovalForm
      bind:comment
      bind:purpose
      purposeReadonly={true}
      {editorCommentLabel}
      {editorCommentLabelTooltip}
      bind:commentErrors={fieldIsValid.comment.errors}
    />
    <th>
      {sgettext('$$ATTACHMENTS$$')}
      <a
        href="#"
        data-toggle="tooltip"
        title={sgettext('$$LIMIT_5_ATTACHMENTS_100MB$$')}
        style="color:#ccc; margin-left:5px;"
      >
        <i class="fas fa-question-circle" />
      </a>
    </th>
    <Attachments
      bind:attachments
      bind:this={mediaInput}
      bind:media
      {cleanupAttachments}
      activityVersionId={avId}
      showLibrary={() => mediaInput.showFileBrowser()}
    />
  </div>
  <div slot="footer">
    <Button
      name={sgettext('$$CANCEL$$')}
      on:click={onCancel}
      disabled={sending}
      type="secondary"
    />
    <Button
      name={sgettext('$$CONFIRM$$')}
      on:click={handleConfirm}
      {sending}
      disabled={sending}
    />
  </div>
  <div slot="additional-info">
    <label for="commentTitleField">
      {sgettext('$$COMMENT_LOG$$')}{' ('}{approvalComments.length}{')'}
    </label>
    <Comments comments={approvalComments} loading={approvalLoading} />
  </div>
</Modal>
